export const StepStatus = {
  PASSED: "passed",
  FAILED: "failed",
  SKIPPED: "skipped",
  PENDING: "pending",
};

export const ScenarioStatus = {
  RUNNING: "running",
  PASSED: "passed",
  FAILED: "failed",
  PENDING: "pending",
};
